// extracted by mini-css-extract-plugin
export default {"parkingZoneBorder":"parking_parkingZoneBorder__32U2L"};